import { render, staticRenderFns } from "./ImageV2.vue?vue&type=template&id=60d4a950"
import script from "./ImageV2.vue?vue&type=script&lang=js"
export * from "./ImageV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports